<app-textile-data-overview
  iconForCard="clients"
  [columnDefs]="getColumnDefs()"
  [listOfTextileData]="listOfCustomers"
  [textileDataService]="customers"
  [textileDataType]="textileDataType.CUSTOMER"
  [gridIdentifier]="GRID_IDENTIFIER"
  [showSearchBar]="false"
></app-textile-data-overview>
